import StepId from "@/model/progress/StepId"
import { providerState, sessionState } from "@/state"

const providerKey = "lendingclub_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "lendingclubResumeAfterFullApply",
            path: `/providers/${providerKey}/resume/after-full-apply`,
            meta: { stepper: false },
            redirect: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
        },
        {
            name: "lendingclubPrequalifyStart",
            path: `/providers/${providerKey}/modes/prequalify/start`,
            redirect: `/providers/${providerKey}/prequalifyAgree`,
        },
        {
            path: `/providers/${providerKey}/prequalifyAgree`,
            name: "lendingclubPrequalifyAgree",
            meta: { step: StepId.PATIENT_INFO },
            component: () => import("@/views/provider/lendingclub/LendingClubPrequalifyAgreeView.vue"),
        },
        {
            name: "lendingclubPrequalifyOfferReviewNext",
            path: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/lendingclub/LendingClubIframeView.vue"),
        },

        {
            name: "lendingclubPending",
            path: `/providers/${providerKey}/pending`,
            meta: { step: StepId.COMPLETE, stepper: false },
            redirect: () => {
                let applyResponse = providerState.getApplyResponse(sessionState.providerKey)
                if (applyResponse?.pendingReasons?.length && applyResponse?.pendingReasons?.includes("verify_email")) {
                    return `/providers/${providerKey}/approved`
                }
                return `/providers/${providerKey}/true-pending`
            },
        },
        {
            name: "lendingclubTruePending",
            path: `/providers/${providerKey}/true-pending`,
            meta: { step: StepId.COMPLETE, stepper: false },
            component: () => import("@/views/apply/PendingView.vue"),
        },
        {
            name: "lendingclubApproved",
            path: `/providers/${providerKey}/approved`,
            meta: { step: StepId.COMPLETE },
            extends: "approved",
            component: () => import("@/views/provider/lendingclub/LendingClubApprovedView.vue"),
        },
        {
            name: "lendingclubExpired",
            path: `/providers/${providerKey}/expired`,
            meta: { step: StepId.COMPLETE },
            component: () => import("@/views/provider/lendingclub/LendingClubExpiredView.vue"),
        },
        {
            name: "lendingclubResumeFromPaymentPlanReview",
            path: `/providers/${providerKey}/resume/from-payment-plan-review`,
            redirect: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
        },
    ],
}
